module.exports = __webpack_public_path__ + "static/media/emergency_management.0debf3af.svg";